import { CreditCardWalletType } from '@generated-types';

export enum Market {
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
}

export interface WalletCreditCardFilter {
    deviceId?: string;
    panReferenceIds?: string[];
    remotePanReferenceIds?: string[];
    tokenReferenceIds?: string[];
    walletType?: CreditCardWalletType;
    isWatchPaired: boolean;
}

export interface VippsStatus {
    available: boolean;
}
